"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.upload = upload;

var _dom = require("@testing-library/dom");

var _click = require("./click");

var _blur = require("./blur");

var _focus = require("./focus");

var _utils = require("./utils");

function upload(element, fileOrFiles, init) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref$applyAccept = _ref.applyAccept,
      applyAccept = _ref$applyAccept === void 0 ? false : _ref$applyAccept;

  var _input$files;

  var input = (0, _utils.isElementType)(element, 'label') ? element.control : element;

  if (!input || !(0, _utils.isElementType)(input, 'input', {
    type: 'file'
  })) {
    throw new TypeError("The ".concat(input === element ? 'given' : 'associated', " ").concat(input == null ? void 0 : input.tagName, " element does not accept file uploads"));
  }

  if ((0, _utils.isDisabled)(element)) return;
  (0, _click.click)(element, init == null ? void 0 : init.clickInit);
  var files = (Array.isArray(fileOrFiles) ? fileOrFiles : [fileOrFiles]).filter(function (file) {
    return !applyAccept || isAcceptableFile(file, input.accept);
  }).slice(0, input.multiple ? undefined : 1); // blur fires when the file selector pops up

  (0, _blur.blur)(element); // focus fires when they make their selection

  (0, _focus.focus)(element); // do not fire an input event if the file selection does not change

  if (files.length === ((_input$files = input.files) == null ? void 0 : _input$files.length) && files.every(function (f, i) {
    var _input$files2;

    return f === ((_input$files2 = input.files) == null ? void 0 : _input$files2.item(i));
  })) {
    return;
  } // the event fired in the browser isn't actually an "input" or "change" event
  // but a new Event with a type set to "input" and "change"
  // Kinda odd...


  var inputFiles = _objectSpread(_objectSpread({}, files), {}, _defineProperty({
    length: files.length,
    item: function item(index) {
      return files[index];
    }
  }, Symbol.iterator, function () {
    var i = 0;
    return {
      next: function next() {
        return {
          done: i >= files.length,
          value: files[i++]
        };
      }
    };
  }));

  (0, _dom.fireEvent)(input, (0, _dom.createEvent)('input', input, {
    target: {
      files: inputFiles
    },
    bubbles: true,
    cancelable: false,
    composed: true
  }));

  _dom.fireEvent.change(input, _objectSpread({
    target: {
      files: inputFiles
    }
  }, init == null ? void 0 : init.changeInit));
}

function isAcceptableFile(file, accept) {
  if (!accept) {
    return true;
  }

  var wildcards = ['audio/*', 'image/*', 'video/*'];
  return accept.split(',').some(function (acceptToken) {
    if (acceptToken.startsWith('.')) {
      // tokens starting with a dot represent a file extension
      return file.name.endsWith(acceptToken);
    } else if (wildcards.includes(acceptToken)) {
      return file.type.startsWith(acceptToken.substr(0, acceptToken.length - 1));
    }

    return file.type === acceptToken;
  });
}